export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5384.b6cfb2f7.jpg";